<template>
  <v-card class="back" style="height: 104px">

        <v-layout column fill-height>

              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span class="body-2 text-uppercase">{{$t('test sms notification')}}</span>
                </v-toolbar-title>

                <v-layout  justify-end>
                <v-tooltip dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'close'"
                  @click="()=>{$emit('close')}">
                    <svg-icon
                      :color="'white'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('close') }}</span>
                </v-tooltip>
              </v-layout>

              </v-toolbar>             

              <v-layout justify-space-between class="pa-2">
                <v-form ref="test_sms_card_form">

                  <v-layout  pa-0>
                    <v-flex xs12  pa-0>                 
                      <v-text-field
                        :data-testid="$options.name + '__text-field_integer__' + 'sms_phone'"
                        v-model="sms_phone"
                        :type="'text'"
                        :required="true"
                        validate-on-blur
                        light
                        auto-grow
                        solo
                        flat
                        :label="$t('sms_phone')"
                        :mask="'#(###) ###-##-##'"
                        class="white"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>

                    </v-flex>
                  </v-layout>

                  
                  
                </v-form>

                <v-layout shrink  justify-end>
                  <v-btn dark small 
                  :data-testid="$options.name + '__btn__' + 'testSmsSend'"
                  :disabled="!sms_phone"
                  @click="()=>testSmsSend()" color="success">{{$t('test')}}</v-btn>
                </v-layout>

              </v-layout>

        </v-layout>

  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

export default Vue.extend({
  name: 'SMS_TEST_CARD',

  components: {
    svgIcon
  },

  props: {},

  data(): {
    sms_phone: string
  } {
    return {
      sms_phone: '',
    }
  },

  computed: {},

  created(): void {
    // Метод предназначен для переопределения при необходимости
  },

  methods: {
    setup(): void {
      // Метод предназначен для переопределения при необходимости
    },

    async testSmsSend(): Promise<void> {
      try {
        this.setLoader('testSmsSend', true)
        const test = await this.$bridge.customQuery('alarm', '/sms/testSms', { phone: this.sms_phone }, 'post')
        console.log(this.$options.name, 'testSmsSend', 'test', test)
        this.setLoader('testSmsSend', false)
      } catch (error) {
        console.error(this.$options.name, 'testSmsSend smth wrong', error)
        this.setLoader('testSmsSend', false)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
